import type { ConsentState } from "./ConsentService";

export class AnalyticsService {
  private events: Array<{ name: string; properties: Record<string, unknown> }> = [];
  private enabled = false;
  private readonly sessionId = `session-${Date.now()}-${Math.random().toString(36).slice(2)}`;

  initialize(consent: ConsentState): void {
    // Intentionally no provider yet. Keep analytics disabled until configured
    // and covered by the same consent decision.
    this.enabled = consent.categories.analytics === "granted";
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("vibwebs:game-analytics-consent", {
        detail: { game_id: "diamond_rush", granted: this.enabled },
      }));
    }
  }

  track(name: string, properties: Record<string, unknown> = {}): void {
    if (!this.enabled) return;
    const event = {
      name,
      properties: {
        game_id: "diamond_rush",
        session_id: this.sessionId,
        timestamp: new Date().toISOString(),
        ...properties,
      },
    };
    this.events.push(event);
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("diamond-rush-analytics", {
        detail: event,
      }));
    }
  }

  getBufferedEvents(): Array<{ name: string; properties: Record<string, unknown> }> {
    return [...this.events];
  }
}
